export const API_URL = process.env.REACT_APP_API_URL;

export const get = (url: string, accessToken: string) => {
    console.log(API_URL);
    return fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    }).then((res) => res.json());
};

export async function fetchWithToken(url: string, token: string) {
    const response = await fetch(`${API_URL}${url}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData || "Failed to fetch ");
    }
    return response.json();
}


export async function deleteWithToken(url: string, token: string) {
    const response = await fetch(`${API_URL}${url}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData || "Failed to fetch ");
    }

    return response.json();
}


export async function patchWithToken(url: string, body: any, token: string) {
    const response = await fetch(`${API_URL}${url}`, {
        method: "PATCH",
        body: body,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData || "Failed to fetch ");
    }

    return response.json();
}



export async function postWithToken(url: string, body: any, token: string) {
    const response = await fetch(`${API_URL}${url}`, {
        method: "POST",
        body: body,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        console.log('post:', response)
        throw new Error(errorData || "Failed to fetch ");
    }

    return response.json();
}

export async function putWithToken(url: string, body: any, token: string) {
    const response = await fetch(`${API_URL}${url}`, {
        method: "PUT",
        body: body,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData || "Failed to fetch ");
    }

    return response.json();
}

